export const CANVAS_SOURCE_GROUP_X = 60;
export const CANVAS_GROUP_WIDTH = 380;
export const CANVAS_GROUP_HEADER_HEIGHT = 68;
export const CANVAS_GROUP_BODY_PADDING = 24;
export const CANVAS_GROUP_VERTICAL_GAP = 64;
export const CANVAS_ROW_SPACING = 68;
export const CANVAS_MIN_GROUP_HEIGHT = CANVAS_GROUP_HEADER_HEIGHT + CANVAS_GROUP_BODY_PADDING * 2 + CANVAS_ROW_SPACING * 2;
export const CANVAS_INTERMEDIATE_COLUMN_X = CANVAS_SOURCE_GROUP_X + CANVAS_GROUP_WIDTH + 200;
export const CANVAS_TRANSFORMATION_COLUMN_X = CANVAS_INTERMEDIATE_COLUMN_X + 120;
export const CANVAS_TARGET_GROUP_X = CANVAS_TRANSFORMATION_COLUMN_X + 360;
export const CANVAS_TRANSFORMATION_COLUMN_STEP = 220;
export const CANVAS_TRANSFORMATION_STEP_DECAY = 0.085;
export const CANVAS_TRANSFORMATION_STEP_MIN = 150;
export const CANVAS_TRANSFORMATION_MAX_DECAY_STEPS = 6;
export const CANVAS_LINK_BRIDGE_HORIZONTAL_JITTER = 14;
export const CANVAS_LINK_BRIDGE_VERTICAL_JITTER = 22;
export const CANVAS_LINK_BRIDGE_VERTICAL_SCALE = 0.32;
export const CANVAS_LINK_BRIDGE_MIDPOINT_SHIFT = 0.54;

// Join badge height added to group header
export const CANVAS_JOIN_BADGE_ROW_HEIGHT = 32;
